import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  findAllCategory,
  insertCategory,
  updateCategory,
  deleteCategory,
  findByIDCategory,
  activeInactiveCategory,
  findAllActiveCategory,
} from "./category.service";
import { getCategoriesWithProductCount } from "../product/product.service";
import { ICategory, ICategoryState, ICategoryWithCount } from "./categoryModel";

const initialState: ICategoryState = {
  loading: false,
  formLoading: false,
  error: "",
  CategoryList: [],
  CategoryWithCountList: [],
  CategoryID: null,
  isDrawerOpen: false,
  CategoryDetail: {
    Title: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteCategoryID: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setCategoryID: (state, action: PayloadAction<number | null>) => {
      state.CategoryID = action.payload;
    },
    clearCategoryID: (state) => {
      state.CategoryID = null;
    },
    clearCategoryDetails: (state) => {
      state.CategoryDetail = initialState.CategoryDetail;
      state.CategoryID = null;
    },
    openDrawer: (state) => {
      state.isDrawerOpen = true;
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false;
      state.CategoryID = null;
      state.CategoryDetail = initialState.CategoryDetail;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeleteCategoryID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteCategoryID = null;
    },
  },
  extraReducers: (builder) => {
    // Find All
    builder.addCase(findAllCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllCategory.fulfilled,
      (state, action: PayloadAction<ICategory[]>) => {
        state.loading = false;
        state.CategoryList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CategoryList = [];
    });

    // Insert
    builder.addCase(insertCategory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(insertCategory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(insertCategory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update
    builder.addCase(updateCategory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCategory.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCategory.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find By ID
    builder.addCase(findByIDCategory.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(findByIDCategory.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CategoryDetail = action.payload;
    });
    builder.addCase(findByIDCategory.rejected, (state, action) => {
      state.formLoading = false;
      state.CategoryDetail = initialState.CategoryDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete
    builder.addCase(deleteCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find All Active
    builder.addCase(findAllActiveCategory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllActiveCategory.fulfilled,
      (state, action: PayloadAction<ICategory[]>) => {
        state.loading = false;
        state.CategoryList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllActiveCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CategoryList = [];
    });

    // Active/Inactive
    builder.addCase(activeInactiveCategory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveCategory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Categories with Product Count
    builder.addCase(getCategoriesWithProductCount.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getCategoriesWithProductCount.fulfilled,
      (state, action: PayloadAction<ICategoryWithCount[]>) => {
        state.loading = false;
        state.CategoryWithCountList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(getCategoriesWithProductCount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CategoryWithCountList = [];
    });
  },
});

export const {
  setCategoryID,
  clearCategoryID,
  clearCategoryDetails,
  openDrawer,
  closeDrawer,
  openDeleteModal,
  closeDeleteModal,
} = categorySlice.actions;
export default categorySlice.reducer;
